enum FormTypes {
  Cashback = 'cashback',
  IphoneForm = 'iphone-form',
  Landing = 'iphone-landing',
  BusinessCreditForm = 'businessCredit-form',
  BankGuaranteesForm = 'bankGuarantees-form',
  BusinessRKOForm = 'biznesRKO-form',
  BusinessAcquiringForm = 'biznesAcquiring-form',
  BusinessCreditAllBanksForm = 'businessCreditAllBanks-form',
}

export default FormTypes;
